import type { ButtonHTMLAttributes } from "react";
import { ScoutIcon } from "./scout-icon";
import { cn } from "../../lib/utils";

export function ScoutButton({
  className,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      type="button"
      {...props}
      className={cn(
        "inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full transition-colors",
        "bg-accent-50 hover:bg-accent-100",
        "dark:bg-accent-500/10 dark:hover:bg-accent-500/20",
        "focus-visible:ring-2 focus-visible:ring-ink dark:focus-visible:ring-[#FAFAF9]",
        className,
      )}
    >
      <ScoutIcon size={22} />
    </button>
  );
}
